import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { RadioButtonGroup } from 'common-components'
import { selectProductLifeReady } from 'quick-quote/product-life-ready/actions'
import { getSelectedProductRokeRaiSoShield } from '../selectors'
import VALUES from 'core/data-model/constants/values'

export const LifeReadyProductSelection = ({ getSelectedProductRokeRaiSoShield, selectProductLifeReady }) => {
  const productLifeReady = [
    {
      text: '6 ปี',
      value: VALUES.ROKE_RAI_SO_SHIELD_CODE.W99FU06,
    },
    {
      text: '12 ปี',
      value: VALUES.ROKE_RAI_SO_SHIELD_CODE.W99FU12,
    },
    {
      text: '18 ปี',
      value: VALUES.ROKE_RAI_SO_SHIELD_CODE.W99FU18,
    },
    {
      text: 'ถึงอายุ 99 ปี',
      value: VALUES.ROKE_RAI_SO_SHIELD_CODE.W99FU99,
    },
  ]

  return (
    <div className="form-group">
      <div className="form-group-title">
        <span className="form-group-title-text">ระยะเวลาการชำระเบี้ยประกัน</span>
      </div>
      <RadioButtonGroup
        keyToGetValue="value"
        className="model-factor"
        onChange={selectProductLifeReady}
        value={getSelectedProductRokeRaiSoShield}
        options={productLifeReady}
      />
    </div>
  )
}

const mapStateToProps = (state) => ({
  getSelectedProductRokeRaiSoShield: getSelectedProductRokeRaiSoShield(state),
})

const mapDispatchToProps = (dispatch) => ({
  selectProductLifeReady: bindActionCreators(selectProductLifeReady, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(LifeReadyProductSelection)
